import { RitzAPI, } from '@moderepo/mode-internal-apis';
import { searchParamsToString, } from '@moderepo/mode-data-state-base';
/**
 * The types of action that can be dispatched to update this sub state.
 */
export var HomeLogsActionType;
(function (HomeLogsActionType) {
    HomeLogsActionType["SET_HOME_MESSAGE_LOGS"] = "set home message logs";
    HomeLogsActionType["SET_HOME_HTTP_LOGS"] = "set home http logs";
})(HomeLogsActionType || (HomeLogsActionType = {}));
/**
 * Create an action to add log entries to the state
 */
export const setHomeMessageLogs = (homeId, entries, searchParams) => {
    return {
        type: HomeLogsActionType.SET_HOME_MESSAGE_LOGS,
        homeId,
        entries,
        searchParams,
    };
};
/**
 * Create an action to add log entries to the state
 */
export const setHomeHttpLogs = (homeId, entries, searchParams) => {
    return {
        type: HomeLogsActionType.SET_HOME_HTTP_LOGS,
        homeId,
        entries,
        searchParams,
    };
};
/**
 * Get Messages logs for a specific home
 * @param homeId - The home we want to get the message log for
 * @param begin - The first date of the log entries we want to get
 * @param end - The last date of the log entries we want to get
 * @param limit - OPTIONAL - The maximum number of entries we want to get
 */
export const fetchHomeMessageLogEntries = (homeId, begin, end, limit) => {
    return async (dataDispatch) => {
        const logs = await RitzAPI.getInstance().getHomeMessageLogEntries(homeId, begin, end, limit);
        await dataDispatch(setHomeMessageLogs(homeId, logs, searchParamsToString({
            begin, end, limit,
        })));
    };
};
/**
 * Get HTTP requests logs for a specific home
 * @param homeId - The home we want to get the http request logs for
 * @param begin - The first date of the log entries we want to get
 * @param end - The last date of the log entries we want to get
 * @param limit - OPTIONAL - The maximum number of entries we want to get
 */
export const fetchHomeHttpLogEntries = (homeId, begin, end, limit) => {
    return async (dataDispatch) => {
        const logs = await RitzAPI.getInstance().getHomeHttpLogEntries(homeId, begin, end, limit);
        await dataDispatch(setHomeHttpLogs(homeId, logs, searchParamsToString({
            begin, end, limit,
        })));
    };
};
